"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpensionStep = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var material_1 = require("@mui/material");
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var color_1 = require("../core/style/color");
var classnames_1 = __importDefault(require("classnames"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var animationDuration = 300;
var useStyles = (0, makeStyles_1.default)(function (t) { return (0, createStyles_1.default)({
    root: {
        '&:not(:first-of-type)': {
            borderTop: "1px solid " + t.palette.divider,
        }
    },
    header: {
        transition: t.transitions.create('all'),
        padding: "0 " + t.spacing(3) + "px",
        height: 68,
        display: 'flex',
        alignItems: 'center',
        fontSize: t.typography.subtitle1.fontSize,
    },
    headerCurrent: {
        fontSize: t.typography.h6.fontSize,
    },
    headerClickable: {
        cursor: 'pointer',
        '&:hover': {
            background: t.palette.background.default,
        }
    },
    i: {
        fontWeight: t.typography.fontWeightMedium,
        borderRadius: '50%',
        color: color_1.colorSuccess,
        marginRight: t.spacing(1),
    },
    body: {
        transition: t.transitions.create('all'),
        overflow: 'hidden',
    },
    content: {
        padding: "0 " + t.spacing(3) + " " + t.spacing(3) + " " + t.spacing(3)
    }
}); });
var ExpensionStep = function (_a) {
    var disabled = _a.disabled, done = _a.done, free = _a.free, isCurrent = _a.isCurrent, index = _a.index, label = _a.label, component = _a.component, goTo = _a.goTo, prev = _a.prev, next = _a.next, isLast = _a.isLast, className = _a.className, autoScroll = _a.autoScroll, other = __rest(_a, ["disabled", "done", "free", "isCurrent", "index", "label", "component", "goTo", "prev", "next", "isLast", "className", "autoScroll"]);
    var $root;
    var classes = useStyles();
    var isCurrentRef = (0, react_1.useRef)();
    var isClickable = function () { return !isCurrent && !disabled; };
    var scrollTop = function () {
        $root === null || $root === void 0 ? void 0 : $root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    (0, react_1.useEffect)(function () {
        isCurrentRef.current = isCurrent;
    }, [isCurrent]);
    (0, react_1.useEffect)(function () {
        if (autoScroll && !isCurrentRef.current && isCurrent)
            setTimeout(scrollTop, animationDuration);
    });
    return (React.createElement("div", __assign({ className: (0, classnames_1.default)(classes.root, className), ref: function (node) { return $root = node !== null && node !== void 0 ? node : undefined; } }, other),
        React.createElement("header", { className: (0, classnames_1.default)(classes.header, isCurrent && classes.headerCurrent, isClickable() && classes.headerClickable), onClick: function () { return goTo(index); } },
            !free && done && !isCurrent && React.createElement(material_1.Icon, { className: classes.i }, "check"),
            !free && React.createElement(React.Fragment, null,
                index + 1,
                ". "),
            label),
        React.createElement(material_1.Collapse, { in: isCurrent, timeout: animationDuration, className: classes.body },
            React.createElement("div", { className: classes.content }, React.cloneElement(component, { prev: prev, next: next, goTo: goTo, free: free, index: index, disabled: disabled, done: done, isCurrent: isCurrent, isLast: isLast })))));
};
exports.ExpensionStep = ExpensionStep;
//# sourceMappingURL=ExpensionStep.js.map